import { useEffect, useState } from "react";
import {
    Link,
    useLocation
} from "react-router-dom";


function Navigation() {

    const [menuOpen, setMenuOpen] =
        useState(false);

    const [dropdownOpen, setDropdownOpen] =
        useState(false);

    const location = useLocation();


    // ==================================================
    // MENÜ BEI SEITENWECHSEL SCHLIESSEN
    // ==================================================

    useEffect(() => {

        setMenuOpen(false);
        setDropdownOpen(false);

    }, [location.pathname]);


    // ==================================================
    // HAMBURGER-MENÜ
    // ==================================================

    function toggleMenu() {

        setMenuOpen(
            (open) => !open
        );
    }


    // ==================================================
    // ÜBER-MICH-UNTERMENÜ
    // ==================================================

    function toggleDropdown() {

        setDropdownOpen(
            (open) => !open
        );
    }


    return (

        <nav className="nav">


            {/* ================================= */}
            {/* HAMBURGER-BUTTON */}
            {/* ================================= */}

            <button
                className="nav-toggle"
                type="button"
                onClick={toggleMenu}
                aria-expanded={menuOpen}
                aria-label="Navigation öffnen oder schliessen"
            >

                <span className="nav-toggle-symbol">
                    {menuOpen ? "✕" : "☰"}
                </span>

                <span>
                    Menü
                </span>

            </button>


            {/* ================================= */}
            {/* HAUPTNAVIGATION */}
            {/* ================================= */}

            <ul
                className={
                    menuOpen
                        ? "nav-list nav-list-open"
                        : "nav-list"
                }
            >

                <li>
                    <Link to="/">
                        News
                    </Link>
                </li>


                {/* ================================= */}
                {/* ÜBER MICH */}
                {/* ================================= */}

                <li
                    className={
                        dropdownOpen
                            ? "dropdown dropdown-open"
                            : "dropdown"
                    }
                >

                    <div className="dropdown-link-row">

                        <Link to="/ueber">
                            Über mich
                        </Link>


                        <button
                            className="dropdown-toggle"
                            type="button"
                            onClick={toggleDropdown}
                            aria-expanded={dropdownOpen}
                            aria-label="Untermenü Über mich öffnen oder schliessen"
                        >

                            {dropdownOpen ? "▲" : "▼"}

                        </button>

                    </div>


                    <ul className="dropdown-menu">

                        <li>
                            <Link to="/weiterbildung">
                                Weiterbildung
                            </Link>
                        </li>

                        <li>
                            <Link to="/werdegang">
                                Werdegang
                            </Link>
                        </li>

                        <li>
                            <Link to="/zertifikate">
                                Zertifikate
                            </Link>
                        </li>

                        <li>
                            <Link to="/diplome">
                                Diplome
                            </Link>
                        </li>

                    </ul>

                </li>


                <li>
                    <Link to="/hobbys">
                        Hobbys
                    </Link>
                </li>


                <li>
                    <Link to="/links">
                        Links
                    </Link>
                </li>


                <li>
                    <Link to="/feedback">
                        Feedback
                    </Link>
                </li>

            </ul>

        </nav>

    );
}


export default Navigation;